<script>
import FilterMainForm from '@/components/Filter/MainForm';

export default {
  components: {
    FilterMainForm,
  },
  props: {
    autoNew: {
      type: Object,
      default: () => ({}),
    },
    autoUsed: {
      type: Object,
      default: () => ({}),
    },
    autoParallelnyiImport: {
      type: Object,
      default: () => ({}),
    },
    autoOrderUrl: {
      type: String,
      default: '',
    },
    newBrands: {
      type: Array,
    },
    city: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      countNewAuto: this.autoNew.count,
      countUsedAuto: this.autoUsed.count,
      countParallelnyiImportAuto: this.autoParallelnyiImport.count,
      tabActive: 'new',
      newBrands: this.newBrands,
    };
  },
  computed: {
    serviceBookingUrl() {
      return ~this.autoOrderUrl.indexOf('/cars-order/')
        ? this.autoOrderUrl
            .replace('/cars-order/', '')
            .concat('/service/#booking')
        : '/service/#booking';
    },
  },
  methods: {
    changeTab(tab) {
      this.tabActive = tab;
    },
    changeCountNewAuto(data) {
      this.countNewAuto = data.count;
    },
    changeCountUsedAuto(data) {
      this.countUsedAuto = data.count;
    },
    changeCountParallelnyiImportAuto(data) {
      this.countParallelnyiImportAuto = data.count;
    },
  },
};
</script>

<template>
  <div>
    <div
      class="flex flex-col sm:flex-row items-center justify-center mx-auto rounded-brand overflow-hidden gap-[15px]"
    >
      <!-- <a
        href="./cars/new/"
        class="flex justify-between sm:justify-center items-center px-4 rounded-brand sm:!rounded-l-brand bg-white w-full sm:w-60 h-12 hover:bg-green hover:text-white filter__links"
      >
        <div class="text-gray-800 text-base mr-3.5">Новые&nbsp;авто</div>
        <div
          v-if="countNewAuto"
          class="text-white bg-green py-1.5 px-2.5 text-xs font-medium filter__counter rounded-brand"
        >
          {{ countNewAuto }}
        </div>
      </a> -->

      <!-- <a
        class="hidden button button_green ml-5 w-40 lg:flex items-center justify-center text-base h-12 hover:text-black hover:bg-blue-light"
        :href="autoOrderUrl"
      >
        Авто на заказ
      </a> -->
    </div>
    <filter-main-form
      v-show="tabActive === 'new'"
      :filter-data="autoNew"
      url-get-data="mainNew/"
      url-set-filter="cars/new/"
      :new-brands="newBrands.brandsVue"
      :countUsedAuto="countUsedAuto"
      :auto-order-url="autoOrderUrl"
      :tabActive="tabActive"
      :service-booking-url="serviceBookingUrl"
      :city="city"
      @change-count="changeCountNewAuto"
      @change-tab="changeTab"
    />
    <filter-main-form
      v-show="tabActive === 'mileage'"
      :filter-data="autoUsed"
      url-get-data="mainUsed/"
      url-set-filter="cars/used/"
      :new-brands="newBrands.brandsVue"
      :countUsedAuto="countUsedAuto"
      :auto-order-url="autoOrderUrl"
      :tabActive="tabActive"
      :service-booking-url="serviceBookingUrl"
      :city="city"
      @change-count="changeCountUsedAuto"
      @change-tab="changeTab"
    />
    <filter-main-form
      v-show="tabActive === 'parallelnyi-import'"
      :filter-data="autoParallelnyiImport"
      url-get-data="mainPartStock/"
      url-set-filter="cars/parallelnyi-import/"
      :countUsedAuto="countUsedAuto"
      :auto-order-url="autoOrderUrl"
      :new-brands="newBrands.brandsVue"
      :tabActive="tabActive"
      :service-booking-url="serviceBookingUrl"
      :city="city"
      @change-count="changeCountParallelnyiImportAuto"
      @change-tab="changeTab"
    />
  </div>
</template>

<style>
.filter__links:hover .filter__counter {
  background-color: #fe5000;
}

.filter__links:hover .text-gray-800 {
  color: white;
}
</style>
